import { createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import IconSearch from '~/domains/design-system/icons/IconSearch';
import { TextInput } from '~/domains/design-system/TextInput';
import dt from '~/testing';

const useStyles = createStyles((theme) => ({
  searchInput: {
    width: '100%',
    maxWidth: '285px',
    height: 36,

    [theme.fn.largerThan('md')]: {
      justifySelf: 'end',
    },
  },
  searchInputWrapper: {
    minHeight: 36,
  },
  searchInputInput: {
    minHeight: 36,
    border: 0,
  },
}));

function FilterSearch({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation('contest');
  const { classes } = useStyles();

  return (
    <TextInput
      data-test-id={dt.contest.quickPicks.detail.general.searchFilterInputField}
      placeholder={t('quickPick.board.filters.searchInputPlaceholder')}
      icon={<IconSearch />}
      classNames={{
        root: classes.searchInput,
        wrapper: classes.searchInputWrapper,
        input: classes.searchInputInput,
      }}
      autoComplete="off"
      onFocus={onClick}
    />
  );
}

export default FilterSearch;
